<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <path class="cls-1" d="m40.03,77.1c-15.17,0-27.5-12.34-27.5-27.5s12.34-27.5,27.5-27.5c1.13,0,2.04.91,2.04,2.04v23.42h23.42c1.13,0,2.04.91,2.04,2.04,0,15.17-12.34,27.5-27.5,27.5Zm-2.04-50.83c-11.96,1.04-21.37,11.11-21.37,23.33,0,12.91,10.5,23.42,23.42,23.42,12.22,0,22.29-9.41,23.33-21.37h-23.33c-1.13,0-2.04-.91-2.04-2.04v-23.33Z"/>
  <path class="cls-2" d="m75.5,42.52h-25.46c-1.13,0-2.04-.91-2.04-2.04V15.02c0-1.13.92-2.04,2.04-2.04,15.17,0,27.5,12.34,27.5,27.5,0,1.13-.92,2.04-2.04,2.04Zm-23.42-4.09h21.28c-.98-11.28-10-20.3-21.28-21.28v21.28Z"/>
</svg>
</template>

<script>
export default {
    name: "ShareByQuarterDashIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #0f5b71;
  }
  .cls-2 {
    fill: #59c5c7;
  }
</style>